var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M18.0673 8.51062L9.50733 4.23062C3.75733 1.35062 1.39733 3.71062 4.27733 9.46062L5.14733 11.2006C5.39733 11.7106 5.39733 12.3006 5.14733 12.8106L4.27733 14.5406C1.39733 20.2906 3.74733 22.6506 9.50733 19.7706L18.0673 15.4906C21.9073 13.5706 21.9073 10.4306 18.0673 8.51062ZM14.8373 12.7506H9.43733C9.02733 12.7506 8.68733 12.4106 8.68733 12.0006C8.68733 11.5906 9.02733 11.2506 9.43733 11.2506H14.8373C15.2473 11.2506 15.5873 11.5906 15.5873 12.0006C15.5873 12.4106 15.2473 12.7506 14.8373 12.7506Z",
          fill: _vm.color
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }